import { Link } from 'react-router-dom';

export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/12380adb-ff42-473d-83d9-042ff7dc24ba.png" 
                alt="Fish Box Studios Logo" 
                className="w-12 h-12"
                style={{ objectFit: 'contain', background: 'transparent' }}
              />
              <span className="text-xl font-bold" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.05em' }}>
                FISHBOX STUDIOS
              </span>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              Creating exceptional board game experiences through innovative design and passionate craftsmanship.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>Quick Links</h3>
            <ul className="space-y-2">
              <li><a onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="hover:text-orange-500 transition-colors cursor-pointer">Home</a></li>
              <li><a onClick={() => { const el = document.getElementById('choke-point'); if (el) el.scrollIntoView({ behavior: 'smooth' }); }} className="hover:text-orange-500 transition-colors cursor-pointer">Our Game</a></li>
              <li><a onClick={() => { const el = document.getElementById('about'); if (el) el.scrollIntoView({ behavior: 'smooth' }); }} className="hover:text-orange-500 transition-colors cursor-pointer">About</a></li>
              <li><a onClick={() => { const el = document.getElementById('contact'); if (el) el.scrollIntoView({ behavior: 'smooth' }); }} className="hover:text-orange-500 transition-colors cursor-pointer">Contact</a></li>
            </ul>
          </div>

          <div>
            <h5 className="text-base font-bold mb-4" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.05em' }}>
              Support
            </h5>
            <ul className="space-y-2">
              <li>
                <a href="#contact" className="text-sm text-gray-400 hover:text-orange-600 transition-colors">
                  Contact Us
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-400 hover:text-orange-600 transition-colors">
                  FAQ
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-400 hover:text-orange-600 transition-colors">
                  Shipping
                </a>
              </li>
              <li>
                <Link to="/privacy-and-terms" className="text-sm text-gray-400 hover:text-orange-600 transition-colors">
                  Privacy &amp; Terms
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h5 className="text-base font-bold mb-4" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.05em' }}>
              Follow Us
            </h5>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-md hover:bg-orange-600 transition-colors">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-md hover:bg-orange-600 transition-colors">
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-md hover:bg-orange-600 transition-colors">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-md hover:bg-orange-600 transition-colors">
                <i className="ri-youtube-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-400">
            © 2025 FishBox Studios. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}